import React, { createContext, useEffect, useState } from "react";

// Create a context with a default value
const ProjectContext = createContext({
    project: null,
    user: null,
});

const ProjectProvider = ({ project, user, children }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [projectData, setProjectData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!user || !project) {
                    throw new Error("Missing user or project data");
                }
                let url =
                    "/wp-json/greenpower/v1/project-data?project=" +
                    project +
                    "&user=" +
                    user;
                const response = await fetch(url);
                const data = await response.json();

                if (!response.ok || data.code) {
                    throw new Error(data.message || "Failed to fetch data");
                }

                setProjectData(data);
                setLoading(false);
            } catch (error) {
                console.error(error);
                setError(error);
                setLoading(false);
            }
        };

        const fetchLocalData = async () => {
            try {
                const response = await fetch(ajaxgp.ajaxurl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams({
                        action: "greenpower_get_project_data",
                        projectID: project,
                        userID: user,
                    }),
                });

                const data = await response.json();

                if (!response.ok || data.code) {
                    throw new Error(
                        data.message || "Failed to fetch local data"
                    );
                }

                setProjectData(data);
                setLoading(false);
            } catch (error) {
                console.error(error);
                setError(error);
                setLoading(false);
            }
        };

        fetchLocalData();
    }, []);

    return (
        <ProjectContext.Provider
            value={{
                projectData,
                error,
                loading,
            }}
        >
            {children}
        </ProjectContext.Provider>
    );
};

export { ProjectContext, ProjectProvider };
